import {createSlice} from '@reduxjs/toolkit';
import {RootState} from './Store';

const initialState = {
  isChatOpen: true,
  isAiInsightsOpen: false,
  isReleaseNotificationOpen: false,
};

export const chatUISlice = createSlice({
  name: 'chatUI',
  initialState,
  reducers: {
    toggleChat: (state) => {
      state.isChatOpen = !state.isChatOpen;
    },
    openChat: (state) => {
      state.isChatOpen = true;
    },
    closeChat: (state) => {
      state.isChatOpen = false;
    },
    toggleAiInsights: (state) => {
      state.isAiInsightsOpen = !state.isAiInsightsOpen;
    },
    openAiInsights: (state) => {
      state.isAiInsightsOpen = true;
    },
    closeAiInsights: (state) => {
      state.isAiInsightsOpen = false;
    },
    openReleaseNotification: (state) => {
      state.isReleaseNotificationOpen = true;
    },
    closeReleaseNotification: (state) => {
      state.isReleaseNotificationOpen = false;
    },
    clearAiChatInsights: (state) => {
      state.isChatOpen = true;
      state.isAiInsightsOpen = false;
    },
  },
});

export const {
  toggleChat,
  openChat,
  closeChat,
  toggleAiInsights,
  openAiInsights,
  closeAiInsights,
  openReleaseNotification,
  closeReleaseNotification,
  clearAiChatInsights,
} = chatUISlice.actions;

export const getchatUIState = (state: RootState) => state.chatUI.isChatOpen;
export const getAiInsightsState = (state: RootState) =>
  state.chatUI.isAiInsightsOpen;

export const getReleaseNotificationState = (state: RootState) =>
  state.chatUI.isReleaseNotificationOpen;

export default chatUISlice.reducer;
